/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AnalyzeLoyaltyPortfolioResponse
 */
export interface AnalyzeLoyaltyPortfolioResponse {
    /**
     * 
     * @type {string}
     * @memberof AnalyzeLoyaltyPortfolioResponse
     */
    markdown: string;
}

/**
 * Check if a given object implements the AnalyzeLoyaltyPortfolioResponse interface.
 */
export function instanceOfAnalyzeLoyaltyPortfolioResponse(value: object): value is AnalyzeLoyaltyPortfolioResponse {
    if (!('markdown' in value) || value['markdown'] === undefined) return false;
    return true;
}

export function AnalyzeLoyaltyPortfolioResponseFromJSON(json: any): AnalyzeLoyaltyPortfolioResponse {
    return AnalyzeLoyaltyPortfolioResponseFromJSONTyped(json, false);
}

export function AnalyzeLoyaltyPortfolioResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AnalyzeLoyaltyPortfolioResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'markdown': json['markdown'],
    };
}

export function AnalyzeLoyaltyPortfolioResponseToJSON(json: any): AnalyzeLoyaltyPortfolioResponse {
    return AnalyzeLoyaltyPortfolioResponseToJSONTyped(json, false);
}

export function AnalyzeLoyaltyPortfolioResponseToJSONTyped(value?: AnalyzeLoyaltyPortfolioResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'markdown': value['markdown'],
    };
}

